import { ProductUnitCategory } from '../enums/productUnitCategory'
import type { ProductUnit } from '../types/productUnit'
import { getProductUnitCategory } from './getProductUnitCategory'

// Custom units may still carry a default code, so they never get one in the XML
export const getProductUnitCode = (unit: ProductUnit | undefined): string | null =>
  unit?.code && getProductUnitCategory(unit) !== ProductUnitCategory.Custom ? unit.code : null
